import React, { forwardRef } from 'react';
interface AppTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const AppTextarea = forwardRef<HTMLTextAreaElement, AppTextareaProps>(({
  label,
  error,
  helperText,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-97">
        {label && <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5" data-id="element-98">
            {label}
          </label>}
        <textarea ref={ref} className={`
            w-full px-3.5 py-2 bg-white dark:bg-dark-subtle border rounded-lg text-base text-gray-900 dark:text-gray-100
            placeholder:text-gray-400 dark:placeholder:text-gray-500 transition-all duration-180 resize-y
            focus:outline-none focus:ring-2 focus:ring-blue-500/20
            disabled:bg-gray-50 dark:disabled:bg-gray-800 disabled:text-gray-500 dark:disabled:text-gray-500 disabled:cursor-not-allowed
            ${error ? 'border-red-300 dark:border-red-700 focus:border-red-500 dark:focus:border-red-500 focus:ring-red-500/20' : 'border-gray-300/80 dark:border-dark-medium focus:border-blue-500 dark:focus:border-blue-500'}
            ${className}
          `} {...props} data-id="element-99" />
        {error && <p className="mt-1.5 text-sm text-red-600 dark:text-red-400" data-id="element-100">
            {error}
          </p>}
        {helperText && !error && <p className="mt-1.5 text-sm text-gray-500 dark:text-gray-400" data-id="element-101">
            {helperText}
          </p>}
      </div>;
});
AppTextarea.displayName = 'AppTextarea';